import { db, firebaseAuth } from './../firestoreConfig';
import { updateProfile, updateEmail } from "firebase/auth";
import { getDoc, setDoc, doc, collection, addDoc,onSnapshot, query, orderBy} from "firebase/firestore"
import ConfigService from "./../services/ConfigService";

export const updateCart = ({
  commit
}, {item, quantity, isAdd}) => {
  // TODO: Call service
  commit('UPDATE_CART', {item, quantity, isAdd});
  if (isAdd) {
    let message_obj = {
      message: `${item.title} succesvol toegevoegd aan winkelmandje`,
      messageClass: "success",
      autoClose: true
    }
    commit('ADD_MESSAGE', message_obj);
  }
}

export const removeItemInCart = ({commit}, {item}) => {
	commit('REMOVE_CART_ITEM', {item});
}

export const registerByEmail = (_, {email, password}) => {
	return firebaseAuth().createUserWithEmailAndPassword(email, password);
}

export const logout = ({commit}) => {
  commit('SET_CART', []);
  return firebaseAuth().signOut();
}

export function loginWithEmail (_, {email, password}) {
  return firebaseAuth().signInWithEmailAndPassword(email, password);
}

export function listenToProductList({commit}) {
	return (products) => {
		commit('UPDATE_PRODUCT_LIST', products.val());
	};
}

export async function getShoppingCart({commit}, {uid, currentCart}) {
	if (uid) {
		console.log("GET cart");
		const docRef = doc(db, `carts/${uid}`);
		const docSnap = await getDoc(docRef);
		if (docSnap.exists() && (!currentCart || currentCart.length == 0)) {
			let cartItemList = docSnap.data().cartItemList;
			commit('SET_CART', cartItemList);
			return docSnap.data();
		}
	} else {
		console.log("User has not logged in");
	}
}

export async function saveShoppingCart(_, {cartItemList, uid, totalAmount}) {
	console.log("save data");
	const docRef = doc(db, `carts/${uid}`);
	try{
		await setDoc(docRef, { cartItemList : cartItemList , totalAmount: totalAmount }, { merge: true });
	}catch(error){
		const errorCode = error.code;
		const errorMessage = error.message;
		console.error("Error: ", errorCode, errorMessage);   
	}
	return
}

export async function getTemplateId(storeId){
	const data = await ConfigService.getConfigStatus();
	const templateId = data?.template?.store?.[storeId] || 0;
    return templateId;
}

export async function saveToTransaction({commit}, {cartItemList, uid, user, time, totalAmount, storeId = 'ouderraad'}) {
	try{
		var ogm = require('belgian-vcs-ogm');
		var randomnr = parseInt(Math.random()*10000000, 10);
		const orderId = parseInt("700" + randomnr +"");
		const newCollectionRef = collection(db, 'transactions', uid , 'orders');
		var structuredMessage = ogm.generateOGM(orderId);
		const delivery = user.delivery || 'digital';

		const templateId = await getTemplateId(storeId);
		//will not save on user
		delete user['delivery'];
		let trans = await addDoc(newCollectionRef, { customer: user, delivery: delivery, templateId:templateId, cartItemList: cartItemList, created: time, totalAmount: totalAmount, orderId: orderId, ogm: structuredMessage, storeId: storeId });
		commit('core/updateTransactionRef', trans.id);
		user.delivery = delivery;
		return { trans: trans, orderId: orderId };
	}catch(error){
		const errorCode = error.code;
		const errorMessage = error.message;
		console.error("Error: ", errorCode, errorMessage);   
	}
	return
}

export async function getTransaction(_, {uid, ref}) {
	try{
		const docRef = await doc(db, `transactions/${uid}/orders/${ref}`);
		const docSnap = await getDoc(docRef);
		if (docSnap.exists()) {
			return docSnap.data();
		}
	}catch(error){
		const errorCode = error.code;
		const errorMessage = error.message;
		console.error("Error: ", errorCode, errorMessage);   
	}
	return
}
export async function getUserData(_, {uid}) {
	try{
		const docRef = doc(db, `users/${uid}`);
		const docSnap = await getDoc(docRef);
		if (docSnap.exists()) {
			return docSnap.data();
		}
	}catch(error){
		const errorCode = error.code;
		const errorMessage = error.message;
		console.error("Error: ", errorCode, errorMessage);   
	}
	return
}

export async function saveUserData(_, {uid, userData}) {
	const userRef = await doc(db, "users", uid);
        try{
			let profile = { email: userData.email, displayName: userData.displayName, phoneNumber: userData.phone }
			await updateProfile(firebaseAuth.currentUser, profile);
			if(firebaseAuth.currentUser.email == ""){
			await updateEmail(firebaseAuth.currentUser, userData.email);
			}
            return await setDoc(userRef, userData, { merge: true });
        }catch(error){
          const errorCode = error.code;
          const errorMessage = error.message;
          console.error("Error: ", errorCode, errorMessage);   
        }
	return
}

export function getSponsors({commit}) {
	var docs=[];
	try{
		onSnapshot(query(collection(db, "sponsors"), orderBy("pos")), (snapshot) => {
			snapshot.forEach((doc) => {
				if(doc.exists){
					docs.push( doc.data());
				}
			});
			commit('SET_SPONSORS', docs);
			return docs;
		});
		
	}catch(error){
		const errorCode = error.code;
		const errorMessage = error.message;
		console.error("Error: ", errorCode, errorMessage);   
	}
	return docs;
}

